import React from 'react';
import PropTypes from 'prop-types';
import styles from '../AlertDetailsCard.module.css';
import Alert from '../../../../../classes/Alert';
import ChannelValueWithUnitsFromChannelKeyObject
  from '../../../../common/ChannelValueWithUnitsFromChannelKeyObject/ChannelValueWithUnitsFromChannelKeyObject';

function AlertLastReading({ activeAlert }) {
  return (
    <div className="col p-0">
      <div className={`card ${styles['gtmd-alert-summary-infobox']} ${styles['infobox-status']}`}>
        <div className={`${styles['infobox-label']} text-nowrap`}>Last Reading</div>
        <div className={`${styles['infobox-value']}`}>
          <span>
            {' '}
            <ChannelValueWithUnitsFromChannelKeyObject
              channelKey={activeAlert.channelKey}
              customUnits={activeAlert.channel.unit}
              value={activeAlert.lastReading.value}
            />
          </span>
        </div>
        <div className={styles['infobox-time']}>
          <span>{activeAlert.lastReading.formattedTimestamp}</span>
        </div>
      </div>
    </div>
  );
}

AlertLastReading.propTypes = {
  activeAlert: PropTypes.instanceOf(Alert).isRequired,
};

export default AlertLastReading;
